/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, HttpService, UtilService } from '@dm/core';
import { ToolService } from 'app/common/services/tool.service';
import { type Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GlobalSearchConfigService {
    constructor(
        private httpService: HttpService,
        private utilService: UtilService,
        private toolService: ToolService,
    ) { }

    /**
     * 查询数据
     * @param id
     * @param url 数据url
     * @param params 需要设置的数据
     * @param options 配置项
     * @param adapt 是否需要执行适配
     */
    getData(id: number | string, url: string, params?: any, options?: BaseRequestOptionsArgs, adapt?: boolean): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl(url).format(id);
        if (params) {
            rest.setParams(params);
        }

        if (adapt) {
            return this.httpService.get(rest, options).pipe(
                tap(({ data }) => {
                    this.adaptData(data);
                }),
            );
        } else {
            return this.httpService.get(rest, options);
        }
    }

    /**
     *  适配从接口查询回来的数据
     *  @param data 请求结果
     */
    adaptData(data: any): void {
        // 适配NIS
        if (data.NISSERVERADDR) {
            const ips = JSON.parse(data.NISSERVERADDR);
            data.primaryIp = ips[0];
            data.standbyIp1 = ips[1];
            data.standbyIp2 = ips[2];
            return;
        }

        // 适配LDAP并解码部分字段
        if (data.LDAPSERVER) {
            const ips = data.LDAPSERVER.split(',');
            data.primaryIp = ips[0];
            data.standbyIp1 = ips[1];
            data.standbyIp2 = ips[2];
        }
        const decodeData = [
            'BASEDN',
            'NETGROUPDN',
            'USERNAME',
            'USERSUFFIX',
            'GROUPSUFFIX',
            'SHADOWSUFFIX',
        ];
        decodeData.forEach((key) => {
            data[key] = this.utilService.decodeHTML(data[key]);
        });
    }
}
